import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const notificationsApi = createApi({
  reducerPath: 'notificationsQueries',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['NotificationPreferences'],
  endpoints: (builder) => ({
    getNotificationPreferences: builder.query({
      query: () => 'users/notification-preferences',
      providesTags: ['NotificationPreferences'],
    }),

    updateNotificationPreferences: builder.mutation({
      query: (body) => ({
        url: 'users/notification-preferences',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['NotificationPreferences'],
    }),
  }),
});

export const { useGetNotificationPreferencesQuery, useUpdateNotificationPreferencesMutation } = notificationsApi;
